"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseMotionButtonPropsInterface = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _purchaseMotions = require("ui-addon-upgrades/_core/common/constants/purchaseMotions");

var PurchaseMotionTypes = _interopRequireWildcard(require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes"));

var PurchaseMotionButtonPropsInterface = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _purchaseMotions.purchaseMotionButtonPropsInterface[PurchaseMotionTypes.BUY_TOUCHLESS], _purchaseMotions.purchaseMotionButtonPropsInterface[PurchaseMotionTypes.TALK_TO_SALES], _purchaseMotions.purchaseMotionButtonPropsInterface[PurchaseMotionTypes.TRIAL], _purchaseMotions.purchaseMotionButtonPropsInterface[PurchaseMotionTypes.BUY_ADDITIONAL_CONTACTS], _purchaseMotions.purchaseMotionButtonPropsInterface[PurchaseMotionTypes.BUY_ADDITIONAL_SEATS], {
  level: _propTypes.default.oneOf([1, 2, 3, 4]).isRequired,
  overrides: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func])),
  passthroughProps: _propTypes.default.objectOf(_propTypes.default.object),
  purchaseMotions: _propTypes.default.arrayOf(_propTypes.default.oneOf(_purchaseMotions.purchaseMotionKeys)).isRequired
});
exports.PurchaseMotionButtonPropsInterface = PurchaseMotionButtonPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/purchaseMotions/PurchaseMotionPropsInterface.js
// module id = 505
// module chunks = 5 6